import React from 'react'

export interface SelectProps {
  data: { label: string; value: any }[]
  selected?: any
  onSelect?: (value: any, e: any) => void
  disableEmpty?: boolean
  emptyLabel?: string
  emptyValue?: any
}

const Select: React.FC<SelectProps> = ({
  data,
  selected,
  onSelect,
  disableEmpty = true,
  emptyLabel = '-',
  emptyValue = ''
}) => {
  return (
    <div className="rs-form-control rs-form-control-wrapper">
      <select
        className="rs-input"
        onChange={(e) => onSelect?.(e.target.value, e)}
        value={selected}
      >
        {!disableEmpty && <option value={emptyValue}>{emptyLabel}</option>}
        {data.map((dataItem, index) => (
          <option
            key={`${dataItem.value}-${index}`}
            value={dataItem.value}
          >
            {dataItem.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default Select
